{
  "common": {
    "ok": "OK",
    "cancel": "Cancel",
    "apply": "Apply",
    "yes": "Yes",
    "no": "No",
    "loading": "Loading...",
    "error": "Error",
    "retry": "Retry",
    "add": "Add"
  },
  "navigation": {
    "home": "Home",
    "favorites": "Favorites",
    "search": "Search"
  },
  "jobs": {
    "noJobs": "No jobs found",
    "loadMore": "Load more",
    "apply": "Apply",
    "save": "Save",
    "unsave": "Unsave"
  },
  "search": {
    "placeholder": "Search job position...",
    "filter": "Filter",
    "clear": "Clear",
    "open": "Search jobs",
    "close": "Close search"
  },
  "alerts": {
    "title": "Job alerts",
    "subtitle": "Get a push notification when new jobs match your saved search.",
    "placeholder": "Keywords (e.g. react remote senior)",
    "empty": "No alerts yet",
    "matchingNow": "{{count}} matching now"
  },
  "description": {
    "openUrlMessage": "Open Url for more information",
    "postedOn": "Posted on",
    "applyViewDetails": "Apply / View Details"
  },
  "error": {
    "title": "Something went wrong",
    "description": "Sorry, no jobs found! This is probably a server or network error.",
    "tryAgain": "Try Again"
  },
  "filter": {
    "refineJobs": "Refine Jobs",
    "title": "Filter",
    "total": "total",
    "reset": "Reset",
    "filterByDate": "Filter by Date",
    "byDate": "By Date",
    "byApplied": "By Applied",
    "appliedOnlyOn": "Applied only: on",
    "appliedOnlyOff": "Applied only: off",
    "postedAfter": "Posted after",
    "filterByTags": "Filter by Tags",
    "byTag": "By Tag",
    "clearAllFavorites": "Clear All Favorites",
    "applyFilters": "Apply Filters"
  },
  "share": {
    "message": "Here follows a great Remote Job Opportunity:\n* Position: {{position}}\n* Company: {{company}}\n* Url: {{url}}",
    "title": "Remote Work App - {{position}} @{{company}}",
    "subject": "Job Shared from Remote Work App",
    "dialogTitle": "Share a Remote Job"
  },
  "datepicker": {
    "selectDate": "Select Date",
    "year": "Year",
    "month": "Month",
    "previousMonth": "Previous month",
    "nextMonth": "Next month",
    "weekdays": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "months": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ]
  },
  "tabs": {
    "allJobs": "All Jobs",
    "favorites": "Favorites",
    "resumeBuilder": "Resume",
    "applications": "Applications",
    "profile": "Profile"
  },
  "favorites": {
    "deleteAll": "Delete all Favorites",
    "empty": "No favorites yet. Tap the heart on a job to save it here."
  },
  "icons": {
    "jobActions": "Job Actions",
    "addToFavorites": "Add to Favorites",
    "removeFromFavorites": "Remove from Favorites",
    "share": "Share",
    "openUrl": "Open URL",
    "markApplied": "Mark as Applied",
    "removeApplied": "Remove Applied"
  },
  "job": {
    "applied": "Applied",
    "fit": "Fit {{score}}%"
  },
  "list": {
    "found": "found"
  },
  "onboarding": {
    "tagline": "Discover curated remote opportunities from around the world!",
    "next": "Next"
  },
  "tour": {
    "skip": "Skip",
    "next": "Next",
    "getStarted": "Get started",
    "slides": {
      "welcome": {
        "title": "Welcome aboard",
        "description": "A quick tour of the main features so you can find your next remote job faster."
      },
      "search": {
        "title": "Search and filter jobs",
        "description": "Search by keyword and refine results by date, tags, or applied status."
      },
      "favorites": {
        "title": "Favorites and applied jobs",
        "description": "Tap the heart to save jobs and mark the ones you've already applied to."
      },
      "tracker": {
        "title": "Track your applications",
        "description": "Mark jobs as applied and follow each one through stages — interview, offer — with notes and dates."
      },
      "alerts": {
        "title": "Get alerts for new matches",
        "description": "Save a search and get a push notification whenever new remote jobs match your keywords."
      },
      "resume": {
        "title": "Build your resume",
        "description": "Create a professional resume, export it as PDF or DOCX, and see how well each job fits your skills."
      },
      "account": {
        "title": "Sign in to sync",
        "description": "Create a free account to back up your resumes, applications, favorites and alerts across all your devices."
      },
      "settings": {
        "title": "Themes and languages",
        "description": "Switch between light and dark mode and pick from 9 languages in settings."
      }
    }
  },
  "theme": {
    "toggle": "Toggle theme"
  },
  "settings": {
    "title": "Settings",
    "theme": "Theme",
    "themeLight": "Light",
    "themeDark": "Dark",
    "language": "Language",
    "open": "Open settings",
    "close": "Close",
    "developer": "Developer",
    "hideAds": "Hide ads",
    "removeAds": {
      "title": "Remove Ads",
      "buy": "Remove ads — {{price}}",
      "restore": "Restore purchases",
      "purchased": "Thanks for supporting RemoteWork! Ads are off.",
      "successTitle": "Ads removed",
      "successMessage": "Thanks for your support! Ads are now off across the app.",
      "errorTitle": "Purchase failed",
      "errorMessage": "Something went wrong. Please try again.",
      "restoreEmptyTitle": "Nothing to restore",
      "restoreEmptyMessage": "No previous purchase was found on this account."
    },
    "tour": "Tour",
    "replayTour": "Replay tour",
    "account": "Account",
    "deleteAccount": {
      "action": "Delete account",
      "confirmTitle": "Delete account?",
      "confirmMessage": "This permanently deletes your account and all synced data — resumes, applications, favorites and alerts. This can't be undone.",
      "errorTitle": "Couldn't delete account",
      "errorMessage": "Something went wrong. Please try again.",
      "reauthMessage": "For your security, please sign out and sign in again, then try deleting your account."
    },
    "about": "About",
    "privacyPolicy": "Privacy policy",
    "website": "Visit website"
  },
  "ad": {
    "sponsored": "Sponsored"
  },
  "consent": {
    "message": "We use analytics cookies to understand how visitors use the site. They stay off until you accept.",
    "accept": "Accept",
    "reject": "Reject"
  },
  "disclaimer": {
    "title": "About the job listings",
    "message": "The jobs shown in this app come from third-party sources and public APIs. We don't post, curate, or control these listings, and we can't guarantee the accuracy, quality, or availability of any position. Always confirm the details directly with the employer before applying.",
    "okCountdown": "OK ({{seconds}})"
  },
  "resume": {
    "title": "Resume Builder",
    "newResume": "New",
    "newResumePrompt": "Name your resume",
    "namePlaceholder": "e.g. CV Frontend",
    "lastModified": "Last modified",
    "discardTitle": "Discard changes?",
    "discardMessage": "You have unsaved edits.",
    "webPlaceholder": {
      "title": "Resume Builder is mobile-only",
      "subtitle": "Open the app on Android or iOS to create and export your resume."
    },
    "actions": {
      "edit": "Edit",
      "duplicate": "Duplicate",
      "delete": "Delete",
      "more": "More options",
      "deleteConfirmTitle": "Delete resume?",
      "deleteConfirmMessage": "Permanently delete \"{{name}}\"? This cannot be undone."
    },
    "empty": {
      "title": "No resumes yet",
      "subtitle": "Build a professional resume and export it as PDF or DOCX.",
      "cta": "Create your first resume",
      "skillsHint": "Add skills like JavaScript, design, leadership…"
    },
    "sections": {
      "personalInfo": "Personal info",
      "experience": "Experience",
      "education": "Education",
      "skills": "Skills",
      "languages": "Languages",
      "links": "Links",
      "template": "Template",
      "contact": "Contact",
      "summary": "Summary",
      "personalization": "Personalization",
      "preview": "Preview"
    },
    "fields": {
      "fullName": "Full name",
      "title": "Professional title",
      "email": "Email",
      "phone": "Phone",
      "location": "Location",
      "website": "Website",
      "summary": "Professional summary",
      "company": "Company",
      "position": "Position",
      "institution": "Institution",
      "degree": "Degree",
      "field": "Field of study",
      "startDate": "Start date",
      "endDate": "End date",
      "current": "I currently work here",
      "present": "Present",
      "description": "Description",
      "skillPlaceholder": "Add a skill",
      "languageName": "Language",
      "languageProficiency": "Proficiency",
      "linkLabel": "Label",
      "linkUrl": "URL",
      "phoneCountryCode": "Country code"
    },
    "proficiency": {
      "basic": "Basic",
      "conversational": "Conversational",
      "fluent": "Fluent",
      "native": "Native"
    },
    "templates": {
      "modern": "Modern",
      "classic": "Classic",
      "minimal": "Minimal",
      "modernDescription": "Two-column layout with a colored sidebar.",
      "classicDescription": "Traditional black and white, single column.",
      "minimalDescription": "Clean, lots of whitespace, no color."
    },
    "buttons": {
      "addExperience": "Add experience",
      "addEducation": "Add education",
      "addLanguage": "Add language",
      "addLink": "Add link",
      "remove": "Remove",
      "save": "Save",
      "discard": "Discard",
      "export": "Export",
      "exportPdf": "Export as PDF",
      "exportDocx": "Export as DOCX",
      "create": "Create",
      "previous": "Previous",
      "next": "Next"
    },
    "export": {
      "preparing": "Preparing your file…",
      "preparingHint": "Choose a format. The file will open in your share sheet when ready.",
      "errorTitle": "Export failed",
      "errorMessage": "Something went wrong while exporting your resume."
    },
    "validation": {
      "invalidEmail": "Please enter a valid email address.",
      "invalidCountryCode": "Use up to 4 digits, optionally prefixed with +.",
      "invalidWebsite": "Enter a valid website (e.g. example.com)."
    },
    "personalization": {
      "title": "Personalize",
      "colorMode": "Color theme",
      "modes": {
        "light": "Light",
        "dark": "Dark"
      },
      "fontFamily": "Font",
      "fonts": {
        "sans": "Sans",
        "serif": "Serif",
        "modern": "Modern",
        "mono": "Mono"
      },
      "fontSize": "Font size",
      "sizes": {
        "title": "Title",
        "subtitle": "Subtitle",
        "body": "Body"
      },
      "increase": "Increase {{field}}",
      "decrease": "Decrease {{field}}"
    },
    "photo": {
      "placeholder": "No photo",
      "choose": "Add photo",
      "change": "Change photo",
      "remove": "Remove",
      "permissionTitle": "Permission required",
      "permissionMessage": "Allow photo library access to pick a profile picture."
    }
  },
  "sort": {
    "recent": "Most recent",
    "bestFit": "Best fit",
    "toggle": "Sort by best fit"
  },
  "applyKit": {
    "title": "Apply kit",
    "hint": "Tap to copy and paste into the application form.",
    "copied": "Copied",
    "openExternal": "Open in browser"
  },
  "applications": {
    "title": "Applications",
    "empty": {
      "title": "No applications yet",
      "subtitle": "Jobs you apply to show up here so you can track their status."
    },
    "status": {
      "applied": "Applied",
      "interviewing": "Interviewing",
      "offer": "Offer",
      "rejected": "Rejected"
    },
    "notesPlaceholder": "Add notes…",
    "remove": "Remove",
    "removeConfirm": "Remove this application?",
    "lastUpdate": "Last update: {{date}}",
    "editDate": "Edit date",
    "addManual": "Add application"
  },
  "auth": {
    "account": "Account",
    "signIn": "Sign in",
    "signUp": "Create account",
    "signOut": "Sign out",
    "title": {
      "signIn": "Welcome back",
      "signUp": "Create your account"
    },
    "email": "Email",
    "password": "Password",
    "showPassword": "Show password",
    "hidePassword": "Hide password",
    "forgotPassword": "Forgot my password?",
    "resetSent": "Password reset email sent — check your inbox.",
    "enterEmailFirst": "Enter your email first.",
    "noAccount": "No account? Create one",
    "haveAccount": "Already have an account? Sign in",
    "criteria": {
      "minLength": "At least 8 characters",
      "uppercase": "One uppercase letter",
      "lowercase": "One lowercase letter",
      "numeric": "One number",
      "special": "One special character"
    },
    "errors": {
      "invalid-email": "That email address looks invalid.",
      "invalid-credential": "Email or password is incorrect.",
      "user-not-found": "No account found with that email.",
      "wrong-password": "Email or password is incorrect.",
      "email-already-in-use": "An account with that email already exists.",
      "weak-password": "That password doesn't meet the requirements.",
      "requires-recent-login": "Please sign in again to continue.",
      "too-many-requests": "Too many attempts. Try again later.",
      "network": "Network error. Check your connection.",
      "not-configured": "Sign-in isn't available right now.",
      "unknown": "Something went wrong. Please try again."
    },
    "continueGoogle": "Continue with Google",
    "continueApple": "Continue with Apple",
    "or": "or",
    "loggedInAnonymous": "Logged in as anonymous",
    "continueAnonymous": "Continue as anonymous",
    "loggedOutWarning": "You're not signed in — your data lives only on this device and could be lost."
  },
  "profile": {
    "title": "Profile",
    "signInRegister": "Sign in / Register",
    "more": "More"
  },
  "applyBrowser": {
    "title": "Apply"
  }
}
